<template>
  <div>
    <TopHeader code="know" />
    <el-dialog
      title="知识上传"
      :visible.sync="dialogMyKnowVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseDialog"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-input v-model="form.id" type="hidden"></el-input>

        <el-form-item
          label="目录"
          prop="catalogid"
          :label-width="formLabelWidth"
        >
          <label>{{ this.treeSelName }}</label>
        </el-form-item>
        <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
          <el-input v-model.trim="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="封面" prop="cover" :label-width="formLabelWidth">
          <el-upload
            ref="upload"
            class="pic-upload"
            action="#"
            list-type="picture-card"
            accept=".jpg,.png"
            :on-preview="handlePictureCardPreview"
            :auto-upload="false"
            :multiple="true"
            :limit="1"
            :on-change="handleChange"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过5MB，最多上传1个
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件" :label-width="formLabelWidth">
          <el-upload
            action=""
            accept=".jpg,.png,.pdf,.mp4"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleUpload"
            style="color:#409eff; border-color:#c6e2ff; background-color:#ecf5ff;"
          >
            <h3>
              选择文件（500M以内）<span style="font-color: blue">{{
                this.fileName
              }}</span>
            </h3>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="描述"
          prop="description"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="form.description"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCloseMyTopic">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
    <section class="container-fluid uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link to="" class="item">知识库</router-link>
              <router-link to="" class="item">
                {{ this.treeSelName }}
              </router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-24 col-sm-6">
            <div class="g-sideMenu">
              <div class="title" @click="handleTreeRoot">全部资源</div>
              <div class="list">
                <el-tree
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :expand-on-click-node="false"
                  :data="treeData.children"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                ></el-tree>
              </div>
            </div>
          </div>

          <div class="col-24 col-sm-18">
            <section class="g-filterSearch uc-ml10">
              <div
                v-for="(item, index) in tabList"
                :key="index"
                class="item"
                :class="item.orderby == query.orderby ? 'on' : ''"
                @click="
                  query.orderby = item.orderby;
                  loadData();
                "
              >
                {{ item.name }}
              </div>
              <div class="search">
                <input
                  type="text"
                  placeholder="请输入您想搜索的资源"
                  class="uc-input"
                  v-model="query.keyword"
                  @keyup.enter="loadData"
                />
                <input
                  type="submit"
                  value="搜索"
                  class="uc-btn blue"
                  @click="loadData"
                />

                <input
                  type="submit"
                  value="上传"
                  class="uc-btn blue"
                  @click="dialogVisible"
                />
              </div>
            </section>

            <section class="g-list style-radius uc-ml10">
              <div class="content-empty" v-if="list.total_count == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div
                v-for="(item, index) in list.items"
                :key="index"
                class="item"
              >
                <router-link
                  :to="{
                    name: 'UserKnowledgeDetails',
                    params: { id: item.id },
                  }"
                  class="con"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-zs.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">{{ item.create_time }}</div>
                  </div>
                </router-link>
              </div>
            </section>

            <el-pagination
              class="uc-prvNxt"
              background
              layout="prev, pager, next"
              hide-on-single-page
              :current-page="query.pageIndex"
              :page-size="query.pageSize"
              :total="list.total_count"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="uc-FixedSideMenu" v-show="false">
      <div class="box">
        <a href="javascript:;;" class="btn-share">
          <img
            src="../../assets/images/icon-share.png"
            alt="我要分享"
            class="uc-icon24"
          />
          我要分享
        </a>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'UserKnowledge',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      dialogMyKnowVisible: false,
      tagSel: 0,
      tabList: [
        {
          name: '最新',
          orderby: 0,
        },
      ],
      form: {
        Id: this.$route.params.id,
        name: '',
        cover: '',
        url: '',
        description: '',
      },
      dialogImageUrl: '',
      dialogImageVisible: false,
      query: {
        catalogId: undefined,
        tagId: undefined,
        pageIndex: 1,
        pageSize: 9,
        orderby: this.$route.query.orderby || 0,
        keyword: undefined,
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      list: [],
      tagList: [],
      treeData: {},
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      treeSelName: '全部',
      formLabelWidth: '100px',
      catalogId: 0,
      fileName: '',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getUserKnowledges();
      this.getCatalogTree();
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },
    handleCloseMyTopic() {
      this.dialogMyKnowVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
    loadData() {
      this.getUserKnowledges();
    },
    dialogVisible() {
      if (this.treeSelName == '全部') {
        this.dialogMyKnowVisible = false;
        this.$message.warning('请先在左侧选择上传文件的资源目录项！');
      } else {
        this.dialogMyKnowVisible = true;
      }
    },
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    // 提交数据
    handleSubmitSure() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.postUserKnowledge();
        }
      });
    },
    // 提交回答
    postUserKnowledge() {
      const formData = new FormData();
      formData.append('id', 0);
      formData.append('name', this.form.name);
      formData.append('description', this.form.description);
      formData.append('CatalogId', this.catalogId);

      formData.append('files', this.form.cover);
      formData.append('files', this.form.url);

      this.$api.userknowledge
        .postUserKnowledge(formData)
        .then((response) => {
          if (response.data.code === 200) {
            const data = response.data.data;

            this.$message.success(response.data.message);
            this.dialogMyKnowVisible = false;
            this.resetForm();
          } else {
            this.$message.warning(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getUserKnowledges() {
      const response = await this.$api.userknowledge.getUserKnowledges(
        this.query
      );
      this.list = response.data.data;
    },
    async getCatalogTree() {
      const response = await this.$api.userknowledge.getCatalogTree();
      this.treeData = response.data.data;
    },
    btnShowFixedMenu() {
      this.showFixedMenu = !this.showFixedMenu;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
    // 切换标签
    handleTagClick(tagId) {
      this.query.tagId = tagId;
      this.loadData();
    },
    // 切换目录
    handleNodeClick(item) {
      this.query.catalogId = item.id;
      this.catalogId = item.id;
      this.treeSelName = item.name;
      this.loadData();
    },
    // 根目录
    handleTreeRoot() {
      this.query.catalogId = undefined;
      this.$refs.tree.setCurrentKey(null);
      this.treeSelName = '全部';

      this.loadData();
    },
    handleChange(file, fileList) {
      const allowExt =
        file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const allowSize = file.size / 1024 / 1024 < 5;
      const index = fileList.indexOf(file);
      if (!allowExt) {
        fileList.splice(index, 1);
        this.$message.error('上传图片只能是 jpg/png 格式!');
      }
      if (!allowSize) {
        fileList.splice(index, 1);
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      this.form.cover = file.raw;
    },
    handleUpload(file, fileList) {
      const allowSize = file.size / 1024 / 1024 < 500;
      const index = fileList.indexOf(file);

      if (!allowSize) {
        fileList.splice(index, 1);
        this.$message.error('上传文件大小不能超过 500MB!');
      }
      this.form.url = file.raw;
      this.fileName = file.name;
    },
  },
};
</script>
